import React, { Component } from 'react';
import PropTypes from "prop-types";
import classNames from 'classnames';
import { translate } from 'react-i18next';


class ProductFilterView extends Component {

  onClick (event, id) {
    this.props.selectCategory(id);
  };

  render() {
    const { language, t } = this.props;
    let { filterCategory } = this.props;
    const categories = this.props.categories;
    filterCategory = !!filterCategory ? filterCategory : 'all';
    return (
      <div className="products__filter">
        <span className="products__filter-title">{t('filters')}:</span>
        <button
          className={
            classNames('products__filter-item', {
              'products__filter-item--active': 'all' === filterCategory
            })
          }
          onClick={(e) => this.onClick(e, 'all')}
        >{t('all_filter')}({categories.toArray()[0].total})</button>
        {categories.valueSeq().map(category => (
          <button
            key={category.id}
            className={
              classNames('products__filter-item', {
                'products__filter-item--active': category.id === parseInt(filterCategory, 10)
              })
            }
            onClick={(e) => this.onClick(e, category.id)}
          >{category[`name_${language}`]}({category.count})</button>
        ))}
      </div>
    )
  }
}

ProductFilterView.propTypes = {
  categories: PropTypes.object,
  selectCategory: PropTypes.func,
  language: PropTypes.string,
  filterCategory: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default translate('translations')(ProductFilterView);


// WEBPACK FOOTER //
// ./src/components/Product/ProductFilterView.js